import { caaMetricsRepositoryAdapter } from '../../infra/repositories/caaMetricsRepositoryAdapter'

export function GetPatientCAAMetricsMonthCase(
  repository: ReturnType<typeof caaMetricsRepositoryAdapter>
) {
  return async (params: {
    patientId: string
    personaName?: string
    month: number
    year: number
  }) => {
    return await repository.getPatientCAAMetricsMonth(params)
  }
}
